'use strict';

var Reflux = require('reflux');

var ModuleConnectionActions = Reflux.createActions(["updateDrag", "stopDragging", "startConnectionAtOutput", "stopConnectionAtInput", "loadModuleConnectionsForProject", "selectConnection", "deleteSelectedConnections"]);

module.exports = ModuleConnectionActions;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/actions/module-connection.js
 **/